import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button
} from '@material-ui/core';

import { ZnDepartmentValue } from 'common/znFields/ZnDepartmentSelect';
import { ZnLanguageValue } from 'common/znFields/ZnLanguageSelect';
import { attachmentActions } from '_actions';
import { ZnButton } from 'common/znFields/ZnButton';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    //minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const AttachmentsTable = props => {

  const { className, attachments, handleAttachmentClick, handleAttachmentClickDelete, ...rest } = props;

  const classes = useStyles();

  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedAttachments;

    if (event.target.checked) {
      selectedAttachments = attachments.map(attachment => attachment.id);
    } else {
      selectedAttachments = [];
    }

    setSelectedAttachments(selectedAttachments);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedAttachments.indexOf(id);
    let newSelectedAttachments = [];

    if (selectedIndex === -1) {
      newSelectedAttachments = newSelectedAttachments.concat(selectedAttachments, id);
    } else if (selectedIndex === 0) {
      newSelectedAttachments = newSelectedAttachments.concat(selectedAttachments.slice(1));
    } else if (selectedIndex === selectedAttachments.length - 1) {
      newSelectedAttachments = newSelectedAttachments.concat(selectedAttachments.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedAttachments = newSelectedAttachments.concat(
        selectedAttachments.slice(0, selectedIndex),
        selectedAttachments.slice(selectedIndex + 1)
      );
    }

    setSelectedAttachments(newSelectedAttachments);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setPage(0);
    setRowsPerPage(event.target.value);
  };

  const handleClickOpen = (id) => {
    handleAttachmentClick(id);
  };

  const handleClickDownload = (mediaId) => {
    attachmentActions.download( mediaId);
  };

  const handleClickDelete = (id) => {
    handleAttachmentClickDelete(id);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Language</TableCell>
                  <TableCell>File</TableCell>
                  <TableCell>Departments</TableCell>
                  <TableCell style={{ textAlign: "center" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {attachments.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map(attachment => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={attachment.id}
                    selected={selectedAttachments.indexOf(attachment.id) !== -1}
                  >

                    <TableCell>
                      <Typography variant="body1">(#{attachment.id}) {attachment.name}</Typography>
                    </TableCell>
                    <TableCell>
                      <ZnLanguageValue value={attachment.language}></ZnLanguageValue>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1">
                        {attachment.fileName}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <ZnDepartmentValue value={attachment.departments} />
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <Button
                        onClick={e => handleClickOpen(attachment.id)}
                        color="primary"
                      >Edit</Button>
                      <Button
                        onClick={e => handleClickDownload(attachment.media[0].id)}
                        color="primary"
                      >DOWNLOAD</Button>
                      <ZnButton
                        onClick={e => handleClickDelete(attachment.id)}
                        color="primary"
                        confirm
                        confirmTitle="Do you really want to delete it ?"
                        confirmText={`Please confirm you want to delete the attachment ${attachment.fileName}.`}
                      >Delete</ZnButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={attachments.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
        />
      </CardActions>
    </Card>
  );
};

AttachmentsTable.propTypes = {
  className: PropTypes.string,
};

export default AttachmentsTable;
